import { selectActiveEntity, selectAllEntities } from '@ngneat/elf-entities';
import { selectRequestStatus } from '@ngneat/elf-requests';
import { map } from 'rxjs/operators';
import {select} from "@ngneat/elf";

import { projectStore } from './projects.store';

export const projectsSelector = {
	projects$: projectStore.pipe(selectAllEntities()),
	activeProject: projectStore.pipe(selectActiveEntity()),
	projectsLoading$: projectStore.pipe(
		selectRequestStatus('projects'),
		map((status) => status.value === 'pending')
	),
	loadingProjectsState$: projectStore.pipe(
		select(state => state.requestsStatus),
		map(statuses => {
			const values = Object.values(statuses).map(state => state.value);
			if (values.includes('pending')) {
				return 'pending';
			} else if (values.every(value => value === 'success')) {
				return 'success';
			} else {
				return ''
			}
		})
	),
	loadingProjectsIds$: projectStore.pipe(
		select(state => state.requestsStatus),
		map(statuses =>
			Object.entries(statuses)
				.filter(
					([key, status]) =>
						key.startsWith('project-') && status.value === 'pending'
				)
				.map(([key]) => key.replace('project-', ''))
		)
	)
};
